import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton'
import { deleteClass } from 'store/actions/schedulingActions'

function DeleteClassButton(props) {

    const { classToDelete } = props

    const [alert, setAlert] = React.useState(false)
    

    const dispatch = useDispatch()

    function handleDelete() {

        if (!classToDelete.platformID) {
            window.alert("Unable to delete this class")
            return
        }


        dispatch(deleteClass(classToDelete))
            .then(() => {
                setAlert(null)
            })
            .catch((err) => {
                window.alert(err)
            })
        

    }

    function confirmDelete() {
        // handleDelete()

        setAlert(
            <SweetAlert
            // warning
            showCancel
            confirmBtnText="Remove"
            confirmBtnBsStyle="danger"
            title="Are you sure you would like to remove this class?"
            onConfirm={() => handleDelete()}
            onCancel={() => setAlert(null)}
            focusCancelBtn
            >
             If you do we recommend you notify your students who have signed up.
            </SweetAlert>
        )
    }
 
    return (
        <div>
            {alert}
            <IconButton style={{color: "#ff4136"}} onClick={() => confirmDelete()}>
                <DeleteOutlineIcon/>    
            </IconButton>
        </div>
    );
}

export default DeleteClassButton